export const IS_TEST_ENVIRONMENT = typeof process !== 'undefined' && process.env?.NODE_ENV === 'test';
